import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent implements OnInit {
  menuItems: any;

  constructor() {}

  ngOnInit(): void {
    this.menuItems = [
      {
        label: 'Client',
        icon: 'pi pi-fw pi-home',
        routerLink: ['/main/client'],
      },
    ];
  }
}
